import { API_URL } from "../../constants";
import * as httpNetworking from "../../httpNetworking";

const URL = API_URL + "/organization";
const VERSION = 0;

export type OrganizationInfoResponse =
    | {
          organizationId: string;
          organizationName: string;
          timeCreated: number;
          organizationFound: true;
          role: "admin" | "member" | "owner";
      }
    | {
          organizationFound: false;
      };

export async function getOrganizationInfo(): Promise<OrganizationInfoResponse> {
    let options: httpNetworking.GETRequestConfig = {
        timeout: 50000
    };

    let result = (await httpNetworking.simpleGETRequest(URL, options, VERSION)).data;
    return result;
}
